import { Entity } from '@nx-data/nx-data';
import { ObservableTable } from '@nx-data/observable-table';

export class NgxTable<T extends Entity> extends ObservableTable<T> {}
